import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';

export interface GetFileTagsResponse {
  status?: string;
  filename?: string;
  s3_key?: string;
  tags: Record<string, string>;
  detail?: string;
}

interface GetFileTagsProps {
  collectionId: string;
  filename: string;
}

export const getFileTags = async ({
  collectionId,
  filename,
}: GetFileTagsProps): Promise<GetFileTagsResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const baseFilename = filename.split('/').pop();
  if (!baseFilename) {
    throw new Error('Filename is required');
  }

  const response = await apiRequest<GetFileTagsResponse>({
    url: `/uploads/${orgId}/${collectionId}/${encodeURIComponent(
      baseFilename,
    )}/tags`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }

  return (response?.data ?? response) as GetFileTagsResponse;
};
